import { z } from "zod";

export const insertLeadSchema = z.object({
  company: z.string().optional().default(""),
  contactPerson: z.string().min(1, "El nombre es obligatorio"),
  phone: z.string().min(1, "El teléfono es obligatorio"),
  email: z.string().email("Email no válido"),
  origin: z.string().optional().default(""),
  destination: z.string().optional().default(""),
  serviceType: z.enum(["urgente", "estandar"]),
  cargoType: z.enum(["paqueteria", "pallet", "otro"]).optional(),
  numberOfItems: z.string().optional().default(""),
  weightMeasures: z.string().optional().default(""),
  pickupDate: z.string().optional().default(""),
  leadSource: z.enum(["home", "urgente", "estandar", "fabricante", "contacto"]),
  message: z.string().optional().default(""),
  rgpdConsent: z.literal(true, { errorMap: () => ({ message: "Debes aceptar la política de privacidad" }) }),
});

export const quickLeadSchema = z.object({
  contactPerson: z.string().min(1, "El nombre es obligatorio"),
  phone: z.string().min(1, "El teléfono es obligatorio"),
  email: z.string().email("Email no válido"),
  serviceType: z.enum(["urgente", "estandar"]),
  origin: z.string().optional().default(""),
  destination: z.string().optional().default(""),
  leadSource: z.enum(["home", "urgente", "estandar", "fabricante", "contacto"]),
  rgpdConsent: z.literal(true, { errorMap: () => ({ message: "Debes aceptar la política de privacidad" }) }),
});

export type InsertLead = z.infer<typeof insertLeadSchema>;
export type QuickLead = z.infer<typeof quickLeadSchema>;

export interface Lead extends InsertLead {
  id: string;
  createdAt: string;
}
